export enum UserRoleEnum {
  SuperAdmin = 'super-admin',
  Admin = 'admin',
  Office = 'office',
  Tester = 'tester',
  SeniorTester = 'senior-tester',
  Guest = 'guest'
}
